import { convertIntToNth } from '../../../utils/helpers/formatting';
import { API_PLAYER_GROUP_BY } from '../../../utils/constants/api';
import {
  PLAYER_GROUP_BY_HEADERS_CONFIG,
  PLAYS_SLIDER_CONFIGS,
  PLAYS_SLIDER_FALLBACK_CONFIG,
} from './PlayerStats.constants';

const { TEAM, PLAYER } = API_PLAYER_GROUP_BY;
/**
 * checks for and formats groupBy columns information in the player stats data
 */
export const addPlayerGroupColumns = (playerStats) =>
  playerStats?.items.map((player) => {
    const playerGroups = player.groups
      // ignore player and team groupings which are applied by default
      ?.filter((group) => group.key !== PLAYER && group.key !== TEAM)
      // take the remaining groupings and format them to "stat" columns
      .reduce(
        (acc, group) => ({
          ...acc,
          // add extra grouping by key and value if exists
          [PLAYER_GROUP_BY_HEADERS_CONFIG[group?.key].id]:
            // use a formatted value if provided by the API
            player?.[PLAYER_GROUP_BY_HEADERS_CONFIG[group?.key].id] ||
            // otherwise use the group object value as fallback (downs and quarters)
            convertIntToNth(group?.value),
        }),
        {},
      );

    return {
      ...player,
      ...playerGroups,
    };
  });

/**
 * picks the "Minimum Total Plays" slider configuration (min/defaultValue/max/step)
 * for a given 0.5 * league-average QB game count, which stands in for season progress.
 * falls back to a configuration that hides nobody when the mean is unusable.
 */
export const getPlaysSliderConfig = (halfMeanGames) => {
  if (!Number.isFinite(halfMeanGames) || halfMeanGames < 0) {
    return PLAYS_SLIDER_FALLBACK_CONFIG;
  }

  return PLAYS_SLIDER_CONFIGS.find(({ maxMean }) => halfMeanGames <= maxMean);
};

/**
 * resolves the value the slider should start on. an explicit ?snaps= value from
 * the URL wins over the configured default, but is clamped into the slider range
 * so a stale deep link cannot filter on a value the slider cannot represent.
 */
export const getInitialMinPlays = (config, urlValue) => {
  const { min, max, defaultValue } = config;

  if (urlValue === null || urlValue === undefined || urlValue === '') {
    return defaultValue;
  }

  const parsedValue = Number(urlValue);

  if (!Number.isFinite(parsedValue)) {
    return defaultValue;
  }

  return Math.min(Math.max(parsedValue, min), max);
};
